<template>
  <v-theme-provider dark>
    <base-section
      id="footer"
      class="grey darken-4"
    >
      <v-responsive
        class="mx-auto"
        max-width="1400"
      >
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
            <base-info />
            </v-col>
            <template v-for="(item, index) in items">
              <v-col
                :key="index"
                cols="12"
                md="3"
              >
                <base-info-card :title="item.name_building" />
                <a
                  :href="'tel:' + item.mobile"
                  class="white--text pa-1 pa-md-0"
                > Мобильный: {{ item.mobile }}</a><br>
                <a
                  :href="'tel:' + item.mobile"
                  class="white--text pa-1 pa-md-0"
                > Городской: {{ item.mobile_2 }}</a><br>
                <a
                  class="white--text pa-1 pa-md-0"
                > Адрес: {{ item.location }}</a><br>
                <a
                  :href="'mailto:' + item.email"
                  class="white--text pa-1 pa-md-0"
                > E-mail: {{ item.email }}</a>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-responsive>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBlockFooter',
    data: () => ({
      items: [
        {
          name_building: 'Бизнес центр 1',
          mobile: '+7 (702) 947-76-34',
          mobile_2: '+7 7172 79-76-00',
          location: 'пр. Кабанбай б. 17 н.п.15 (блок А)',
          email: 't.nurpeiis@ibc.kz',
        },
        {
          name_building: 'Бизнес центр 2',
          mobile: '+7 (702) 947-76-34',
          mobile_2: '+7 7172 79-76-00',
          location: 'пр. Кабанбай б. 17 н.п.14 (блок Е)',
          email: 't.nurpeiis@ibc.kz',
        },
        {
          name_building: 'Бизнес центр 3',
          mobile: '+7 (702) 947-76-34',
          mobile_2: '+7 7172 79-76-00',
          location: 'пр. Кабанбай б. 19 (блок С,Е)',
          email: 't.nurpeiis@ibc.kz',
        },
      ],
    }),
  }
</script>

<style lang="sass">
  #info-alt a
    text-decoration: none
</style>
